import { c as _c } from "react/compiler-runtime";
import { Children } from 'react';
import type { MenuListProps } from 'react-select';
import { FixedSizeList as List } from 'react-window';
const OPTION_HEIGHT = 36;
const ROWS = 6;
const MARGIN = 8;
const MenuList = t0 => {
  const $ = _c(5);
  const {
    innerRef,
    options,
    children,
    getValue
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== getValue || $[2] !== innerRef || $[3] !== options) {
    const [value] = getValue();
    const length = Children.count(children);
    const getInitialOffset = () => {
      if (options.indexOf(value) !== -1) {
        if (Array.isArray(children) && children.length >= ROWS) {
          if (options.indexOf(value) >= ROWS) {
            return options.indexOf(value) * OPTION_HEIGHT - OPTION_HEIGHT * 5;
          }
        }
      }
      return 0;
    };
    const height = length >= ROWS ? OPTION_HEIGHT * ROWS - MARGIN : length * OPTION_HEIGHT + 2 * MARGIN;
    t1 = Array.isArray(children) ? <List height={height} initialScrollOffset={getInitialOffset()} itemCount={length} itemSize={OPTION_HEIGHT} width="100%" className="[&>div>div]:mt-2">{t2 => {
        const {
          style,
          index
        } = t2;
        return <div style={style}>{children[index]}</div>;
      }}</List> : <div ref={innerRef}>{children}</div>;
    $[0] = children;
    $[1] = getValue;
    $[2] = innerRef;
    $[3] = options;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default MenuList;